import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { packageSchema } from '../../../schemas'

export default function New({
  account,
  accounts,
  navigation
}) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Package"
    >
      <BackLink href="/manage/packages">Back to Packages</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={packageSchema}
          resource="package"
          endpoint="/manage/packages"
          backLink="/manage/packages"
          submitLabel="Create Package"
          defaultValues={{
            name: '',
            description: '',
            base_price_pence: '',
            min_guests: 1,
            max_guests: '',
            duration_minutes: '',
            deposit_amount_pence: '',
            active: true,
            image: null,
            menu_document: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g., Funeral Tea, Birthday Party"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={3}
                errors={errors}
                placeholder="Describe what's included in this package"
              />

              <FormFieldController
                control={control}
                name="base_price_pence"
                label="Base Price (per person)"
                type="currency"
                required
                errors={errors}
              />

              <div className="grid grid-cols-2 gap-4">
                <FormFieldController
                  control={control}
                  name="min_guests"
                  label="Minimum Guests"
                  type="number"
                  errors={errors}
                />

                <FormFieldController
                  control={control}
                  name="max_guests"
                  label="Maximum Guests"
                  type="number"
                  errors={errors}
                />
              </div>

              <FormFieldController
                control={control}
                name="duration_minutes"
                label="Duration (minutes)"
                type="number"
                errors={errors}
                placeholder="e.g., 120"
              />

              <FormFieldController
                control={control}
                name="deposit_amount_pence"
                label="Deposit Amount"
                type="currency"
                hint="Leave empty for no deposit. When set, guests pay this amount upfront when booking."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="image"
                label="Image"
                type="file"
                accept="image/*"
                hint="Optional. JPG, PNG or WebP recommended."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="menu_document"
                label="Menu Document"
                type="file"
                accept=".pdf,.doc,.docx"
                hint="Optional. PDF or Word document."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                defaultValue={true}
                hint="Uncheck to hide this package from guests"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
